import { render, staticRenderFns } from "./XlsIcon.vue?vue&type=template&id=02f55d36&"
import script from "./XlsIcon.vue?vue&type=script&lang=js&"
export * from "./XlsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports